import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const accelo = defineConnector({
  identifier: "accelo",
  name: "Accelo",
  tagLine: "Professional services automation",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://[^/]*\\.api\\.accelo\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Accelo instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Accelo instance.",
        },
        {
          kind: "input",
          label: "Accelo Domain",
          placeholder: "domain",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The subdomain of your Accelo account (e.g. https://domain.api.accelo.com)",
        },
      ],
    },
    {
      title: "Create an Accelo app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Accelo API docs](https://api.accelo.com/docs/) and then, in Accelo, go to **Configuration** → **API applications** to create an OAuth app. Copy the client ID and client secret for the app, and note your Accelo subdomain.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/accelo/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Accelo account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Accelo account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.subdomain}.api.accelo.com/oauth2/v0/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.subdomain}.api.accelo.com/oauth2/v0/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.api.accelo.com/`,
  },
  publicEnvVars: ({ subdomain }) => ({
    ACCELO_URL: subdomain ? `https://${subdomain}.api.accelo.com` : "",
  }),
});
